import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "../../RoutersCst";
import CorporateDetailV2Layout from "@pages/Shared/CorporateDetailV2Layout";
import CatalogV2 from "@pages/Contents/V2/Corporate/Catalog";
import AddActivityV2 from "@pages/Contents/V2/Corporate/Catalog/AddActivity";
import EditActivityV2 from "@pages/Contents/V2/Corporate/Catalog/EditActivity";
import EditionsListPage from "@pages/Contents/V2/Corporate/Catalog/Editions/EditionsListPage";
import AddEditionPage from "@pages/Contents/V2/Corporate/Catalog/Editions/AddEditionPage";
import EditionDetailPage from "@pages/Contents/V2/Corporate/Catalog/Editions/EditionDetailPage";
import AddCourseV2 from "@pages/Contents/V2/Corporate/Catalog/AddCourse";
import EditCourseV2 from "@pages/Contents/V2/Corporate/Catalog/EditCourse";
import AddPathV2 from "@pages/Contents/V2/Corporate/Catalog/AddPath";
import EditPathV2 from "@pages/Contents/V2/Corporate/Catalog/EditPath";

const useV2Routes = (): RouteObject => {
  const { user, isInclude } = useIsInclude();

  return {
    path: "v2",
    children: [
      {
        path: "corporate/:id/detail",
        element: (
          <ProtectedRoute isAllowed={!!user}>
            <CorporateDetailV2Layout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "catalog",
            element: <CatalogV2 />,
          },
          {
            path: "catalog/activities/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <AddActivityV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/edit",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditActivityV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/duplicate",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditActivityV2 duplication />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/editions",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditionsListPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/editions/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <AddEditionPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/editions/:editionId",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditionDetailPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/activities/:idLO/editions/:editionId/edit",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <AddEditionPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/courses/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <AddCourseV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/courses/:idCourse/edit",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditCourseV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/courses/:idCourse/duplicate",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditCourseV2 duplication />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/paths/add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <AddPathV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/paths/:idPath/edit",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditPathV2 />
              </ProtectedRoute>
            ),
          },
          {
            path: "catalog/paths/:idPath/duplicate",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "corporate&&corporate.catalog&&learning_catalogue.learning_object.write",
                )}
              >
                <EditPathV2 duplication />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  };
};

export default useV2Routes;
